import { style } from '@/styles/globals';
import { pr } from '@/utils/pxToRem';
import { Grid, Typography, Stack } from '@mui/material';
import React from 'react';

interface AboutUsLineProps {
  content: any;
  title: string;
  imageUrl: string;
  align: 'left' | 'right';
}

const AboutUsLine: React.FC<AboutUsLineProps> = ({
  content,
  title,
  imageUrl,
  align,
}) => (
  <Stack
    spacing={pr`24px`}
    alignItems="center"
  >
    <Typography
      component="h2"
      variant="heading1"
      color={style.color.black1}
      fontWeight="500"
    >
      {title}
    </Typography>
    <Grid
      container
      flexDirection={align === 'left' ? 'row' : 'row-reverse'}
      width="100%"

    >
      <Grid
        item
        xs={12}
        sm={12}
        md={5.8}
        sx={{
          maxHeight: '200px',
          height: '200px',
        }}
      >
        <img
          src={imageUrl}
          alt="logo"
          className="lazyload"
          style={{
            objectFit: 'fill',
            borderRadius: '6px',
            height: '200px',
            width: '100%',
          }}
        />
      </Grid>
      <Grid
        item
        display="flex"
        alignItems="center"
        xs={12}
        sm={12}
        md={6.2}
        marginTop={pr`24px`}
      >
        <Stack
          spacing={pr`24px`}
          paddingLeft={{
            xs: 0,
            md: align === 'left' ? '64px' : 0,
          }}
          paddingRight={{
            xs: 0,
            md: align === 'left' ? 0 : '64px',
          }}
        >
          <Typography variant="body2">
            <div dangerouslySetInnerHTML={{ __html: content }} />
          </Typography>
        </Stack>
      </Grid>
    </Grid>
  </Stack>
);

export default AboutUsLine;
